import { PeriodName } from "@/models";

export function getPeriodMonth(number: number) {
    switch (number) {
        case 1:
            return PeriodName.January;
        case 2:
            return PeriodName.February;
        case 3:
            return PeriodName.March;
        case 4:
            return PeriodName.April;
        case 5:
            return PeriodName.May;
        case 6:
            return PeriodName.June;
        case 7:
            return PeriodName.July;
        case 8:
            return PeriodName.August;
        case 9:
            return PeriodName.September;
        case 10:
            return PeriodName.October;
        case 11:
            return PeriodName.November;
        case 12:
            return PeriodName.December;
        default:
            return PeriodName.January;
    }
}
export function isPreviousPeriodSameAsPreviousYear(period: string): boolean {
    return period === PeriodName.Year || period === PeriodName.YearToDate || period === PeriodName.NineMonths;
}

export function toPeriodName(periodName: string): PeriodName {
    if (periodName in PeriodName) {
        return PeriodName[periodName as keyof typeof PeriodName];
    }
    return PeriodName.Quarter;
}
export function getPeriodStartAndEndDates(year: number, period: PeriodName): [Date, Date] {
    let start: Date;
    let end: Date;
    let currentTime = new Date();
    const timeNowThatYear = new Date(year, currentTime.getMonth(), currentTime.getDate());

    switch (period) {
        case PeriodName.January:
            start = new Date(year, 0, 1);
            end = new Date(year, 0, 31);
            break;
        case PeriodName.February:
            start = new Date(year, 1, 1);
            end = new Date(year, 2, 0);
            break;
        case PeriodName.March:
            start = new Date(year, 2, 1);
            end = new Date(year, 2, 31);
            break;
        case PeriodName.April:
            start = new Date(year, 3, 1);
            end = new Date(year, 3, 30);
            break;
        case PeriodName.May:
            start = new Date(year, 4, 1);
            end = new Date(year, 4, 31);
            break;
        case PeriodName.June:
            start = new Date(year, 5, 1);
            end = new Date(year, 5, 30);
            break;
        case PeriodName.July:
            start = new Date(year, 6, 1);
            end = new Date(year, 6, 31);
            break;
        case PeriodName.August:
            start = new Date(year, 7, 1);
            end = new Date(year, 7, 31);
            break;
        case PeriodName.September:
            start = new Date(year, 8, 1);
            end = new Date(year, 8, 30);
            break;
        case PeriodName.October:
            start = new Date(year, 9, 1);
            end = new Date(year, 9, 31);
            break;
        case PeriodName.November:
            start = new Date(year, 10, 1);
            end = new Date(year, 10, 30);
            break;
        case PeriodName.December:
            start = new Date(year, 11, 1);
            end = new Date(year, 11, 31);
            break;
        case PeriodName.Q1:
            start = new Date(year, 0, 1);
            end = new Date(year, 2, 31);
            break;
        case PeriodName.Q2:
            start = new Date(year, 3, 1);
            end = new Date(year, 5, 30);
            break;
        case PeriodName.Q3:
            start = new Date(year, 6, 1);
            end = new Date(year, 8, 30);
            break;
        case PeriodName.Q4:
            start = new Date(year, 9, 1);
            end = new Date(year, 11, 31);
            break;
        case PeriodName.H1:
            start = new Date(year, 0, 1);
            end = new Date(year, 5, 30);
            break;
        case PeriodName.H2:
            start = new Date(year, 6, 1);
            end = new Date(year, 11, 31);
            break;
        case PeriodName.NineMonths:
            start = new Date(year, 0, 1);
            end = new Date(year, 8, 30);
            break;
        case PeriodName.Year:
            start = new Date(year, 0, 1);
            end = new Date(year, 11, 31);
            break;
        case PeriodName.Quarter: {
            start = new Date(year, Math.round(timeNowThatYear.getMonth() / 3) * 3, 1);
            const nextQuarterStartDate = new Date(year, Math.round(timeNowThatYear.getMonth() / 3) * 3 + 3, 1);
            nextQuarterStartDate.setDate(nextQuarterStartDate.getDate() - 1);
            end = nextQuarterStartDate;
            break;
        }
        case PeriodName.YearToDate:
            start = new Date(year, 0, 1);
            end = timeNowThatYear;
            break;
        case PeriodName.MonthToDate:
            start = new Date(year, timeNowThatYear.getMonth(), 1);
            end = timeNowThatYear;
            break;
        case PeriodName.MonthFirstTill10nth:
            start = new Date(year, timeNowThatYear.getMonth(), 1);
            end = new Date(year, timeNowThatYear.getMonth(), 10);
            break;
        case PeriodName.Month11nthTill20nth:
            start = new Date(year, timeNowThatYear.getMonth(), 11);
            end = new Date(year, timeNowThatYear.getMonth(), 20);
            break;
        case PeriodName.Month21stTillEnd:
            start = new Date(year, timeNowThatYear.getMonth(), 21);
            end = new Date(year, timeNowThatYear.getMonth() + 1, 0);
            break;
        case PeriodName.QuarterToDate:
            start = new Date(year, Math.round(timeNowThatYear.getMonth() / 3) * 3, 1);
            end = timeNowThatYear;
            break;
        default:
            start = new Date(year, 0, 1);
            end = new Date(year, 0, 31);
            break;
    }

    return [start, end];
}

function formatDate(date: Date): string {
    return date.toLocaleDateString("en-US", { day: "2-digit", month: "short" });
}

export function periodNameToOverviewCardString(year: number, period: PeriodName): string {
    let [start, end] = getPeriodStartAndEndDates(year, period);
    let formattedStart = formatDate(start);
    let formattedEnd = formatDate(end);
    return `${formattedStart} - ${formattedEnd}`;
}

export function getPeriodType(period: string): string {
    let periodValue: PeriodName = PeriodName.NotSet;
    if (period in PeriodName) {
        periodValue = PeriodName[period as keyof typeof PeriodName];
    }
    if (periodValue === PeriodName.NotSet) {
        return "Period";
    }
    switch (periodValue) {
        case PeriodName.January:
        case PeriodName.February:
        case PeriodName.March:
        case PeriodName.April:
        case PeriodName.May:
        case PeriodName.June:
        case PeriodName.July:
        case PeriodName.August:
        case PeriodName.September:
        case PeriodName.October:
        case PeriodName.November:
        case PeriodName.December:
        case PeriodName.Month:
        case PeriodName.MonthToDate:
            return "Month";
        case PeriodName.MonthFirstTill10nth:
            return "Month: 1st - 10th";
        case PeriodName.Month11nthTill20nth:
            return "Month: 11th - 20th";
        case PeriodName.Month21stTillEnd:
            return "Month: 21st - end";
        case PeriodName.Q1:
        case PeriodName.Q2:
        case PeriodName.Q3:
        case PeriodName.Q4:
        case PeriodName.Quarter:
        case PeriodName.QuarterToDate:
            return "Quarter";
        case PeriodName.H1:
        case PeriodName.H2:
            return "Half";
        case PeriodName.NineMonths:
            return "Nine months";
        case PeriodName.Year:
        case PeriodName.YearToDate:
            return "Year";
        default:
            return "Month";
    }
}

export function getPeriodByValue(value: PeriodName) {
    return Object.keys(PeriodName).find((key) => PeriodName[key as keyof typeof PeriodName] === value);
}

export function dateToString(date: Date | undefined) {
    if (!date) {
        return "";
    }
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
}

export function getPreviousPeriodDates(startDate: Date, endDate: Date): [Date, Date] {
    let diff = endDate.getTime() - startDate.getTime();
    let newEndDate = new Date(startDate.getTime());
    newEndDate.setDate(newEndDate.getDate() - 1);
    let newStartDate = new Date(newEndDate.getTime() - diff);
    return [newStartDate, newEndDate];
}

export function getPreviousYearDates(startDate: Date, endDate: Date): [Date, Date] {
    let newEndDate = new Date(endDate.getTime());
    let newStartDate = new Date(startDate.getTime());
    newStartDate.setFullYear(newStartDate.getFullYear() - 1);
    newEndDate.setFullYear(newEndDate.getFullYear() - 1);
    return [newStartDate, newEndDate];
}

function getMonthPeriodFromDate(date: Date): PeriodName {
    return getPeriodMonth(date.getMonth() + 1);
}

function getQuarterStart(name: PeriodName): PeriodName {
    switch (name) {
        case PeriodName.January:
        case PeriodName.February:
        case PeriodName.March:
            return PeriodName.Q1;
        case PeriodName.April:
        case PeriodName.May:
        case PeriodName.June:
            return PeriodName.Q2;
        case PeriodName.July:
        case PeriodName.August:
        case PeriodName.September:
            return PeriodName.Q3;
        case PeriodName.October:
        case PeriodName.November:
        case PeriodName.December:
            return PeriodName.Q4;
        default:
            return PeriodName.NotSet;
    }
}

function getPreviousPeriod(period: PeriodName): PeriodName {
    switch (period) {
        case PeriodName.January:
            return PeriodName.December;
        case PeriodName.February:
            return PeriodName.January;
        case PeriodName.March:
            return PeriodName.February;
        case PeriodName.April:
            return PeriodName.March;
        case PeriodName.May:
            return PeriodName.April;
        case PeriodName.June:
            return PeriodName.May;
        case PeriodName.July:
            return PeriodName.June;
        case PeriodName.August:
            return PeriodName.July;
        case PeriodName.September:
            return PeriodName.August;
        case PeriodName.October:
            return PeriodName.September;
        case PeriodName.November:
            return PeriodName.October;
        case PeriodName.December:
            return PeriodName.November;
        case PeriodName.Q1:
            return PeriodName.Q4;
        case PeriodName.Q2:
            return PeriodName.Q1;
        case PeriodName.Q3:
            return PeriodName.Q2;
        case PeriodName.Q4:
            return PeriodName.Q3;
        case PeriodName.H1:
            return PeriodName.H2;
        case PeriodName.H2:
            return PeriodName.H1;
        case PeriodName.NineMonths:
        case PeriodName.Year:
        case PeriodName.YearToDate:
            return period;
        default:
            return PeriodName.NotSet;
    }
}

export function getPreviousPeriodStartAndEndDates(year: number, period: PeriodName): [Date, Date] {
    const currentDate = new Date();
    const currentMonth = getMonthPeriodFromDate(currentDate);
    const currentQuarter = getQuarterStart(currentMonth);
    let periodYear = year;

    if (period === PeriodName.Quarter) {
        period = currentQuarter;
    }
    if (period === PeriodName.Month) {
        period = currentMonth;
    }

    // Adjust year for periods that need to go to previous year
    if (
        period === PeriodName.January ||
        (period === PeriodName.MonthToDate && currentMonth === PeriodName.January) ||
        period === PeriodName.Q1 ||
        period === PeriodName.H1 ||
        period === PeriodName.NineMonths ||
        period === PeriodName.Year ||
        period === PeriodName.YearToDate ||
        (period === PeriodName.QuarterToDate && currentQuarter === PeriodName.Q1)
    ) {
        periodYear--;
    }

    const previousPeriod = getPreviousPeriod(period);

    if (previousPeriod !== PeriodName.NotSet) {
        return getPeriodStartAndEndDates(periodYear, previousPeriod);
    } else {
        if (period === PeriodName.MonthToDate || period === PeriodName.MonthFirstTill10nth || period === PeriodName.Month11nthTill20nth) {
            const [start, end] = getPeriodStartAndEndDates(periodYear, period);
            const prevMonth = new Date(start);
            prevMonth.setMonth(prevMonth.getMonth() - 1);
            const prevEnd = new Date(end);
            prevEnd.setMonth(prevEnd.getMonth() - 1);
            return [prevMonth, prevEnd];
        }
        if (period === PeriodName.Month21stTillEnd) {
            const currentDate = new Date();
            const prevMonthEnd = new Date(periodYear, currentDate.getMonth() - 1 + 1, 0);
            const prevMonthStart = new Date(periodYear, currentDate.getMonth() - 1, 21);
            return [prevMonthStart, prevMonthEnd];
        }
        if (period === PeriodName.QuarterToDate) {
            // Get the current quarter start month (0-11)
            const currentQuarterStartMonth = Math.floor(currentDate.getMonth() / 3) * 3;
            // Get the previous quarter start month
            const previousQuarterStartMonth = currentQuarterStartMonth - 3;

            // Adjust year if previous quarter is in previous year
            const previousQuarterYear = previousQuarterStartMonth < 0 ? year - 1 : year;
            // Adjust month if it's negative (Q4 of previous year)
            const adjustedPreviousQuarterStartMonth = previousQuarterStartMonth < 0 ? 9 : previousQuarterStartMonth;

            const previousQuarterStart = new Date(previousQuarterYear, adjustedPreviousQuarterStartMonth, 1);
            const previousQuarterEnd = new Date(previousQuarterYear, adjustedPreviousQuarterStartMonth + 2, currentDate.getDate());
            return [previousQuarterStart, previousQuarterEnd];
        }
        return getPeriodStartAndEndDates(periodYear, period);
    }
}

export function getPreviousYearStartAndEndDates(year: number, period: PeriodName): [Date, Date] {
    const [startDate, endDate] = getPeriodStartAndEndDates(year, period);
    startDate.setFullYear(startDate.getFullYear() - 1);
    endDate.setFullYear(endDate.getFullYear() - 1);

    return [startDate, endDate];
}
